<template>
  <div id="flowChartList">
    <EbHeader>
      <EbBreakCrumb slot="breakCrumb" />
      <eb-search @search-click="searchData" slot="search" />
    </EbHeader>
    <div class="button-group">
      <el-button class="eb-button-red eb-button-small" @click="isSaveVisible=true">添加</el-button>
      <el-button :disabled="selectFlowChart.length!==1" class="eb-button-red eb-button-small" @click="isEditVisible=true">修改信息</el-button>
      <FlowchartBtnEdit :flowId="selectFlowChart[0]&&selectFlowChart[0].flowId" :disabled="selectFlowChart.length!==1" class="eb-button-red eb-button-small"/>
      <FlowchartBtnView :flowId="selectFlowChart[0]&&selectFlowChart[0].flowId" :disabled="selectFlowChart.length!==1" class="eb-button-red eb-button-small" />
      <el-button :disabled="selectFlowChart.length!==1" class="eb-button-red eb-button-small" @click="removeFlowChartBtn">删除</el-button>
    </div>
    <div class="table-box">
      <div class="eb-table">
        <el-table :data="flowChartList" :stripe="true" ref="flowChartRef" row-key="flowId" style="width: 100%" @selection-change="handleSelectionChange">
          <el-table-column :reserve-selection="true" type="selection" width="55"></el-table-column>
          <el-table-column type="index" label="序号" width="75"></el-table-column>
          <el-table-column prop="flowName" label="名称"></el-table-column>
          <el-table-column prop="flowType" label="应用流程" width="200">
            <template slot-scope="scope">
              <span>{{scope.row.flowType|FlowChartType}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="flowInfo" label="描述" width="200"></el-table-column>
          <el-table-column prop="createTime" label="创建时间" width="140">
            <template slot-scope="scope">
              <span>{{scope.row.createTime|dateTimeStandardFormat}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="updateTime" label="修改时间" width="140">
            <template slot-scope="scope">
              <span>{{scope.row.updateTime|dateTimeStandardFormat}}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <eb-pagination class="pagination-box" :current-page.sync="flowChartParams.page" v-if="listSize" @current-change="paginationData" :total="listSize" />
    </div>
    <SaveFlowChart @onSuccessSaveFlowChart="onSuccess" :isVisible.sync="isSaveVisible" />
    <EditFlowChart @onSuccessEditFlowChart="onSuccess" v-if="selectFlowChart.length==1" :isVisible.sync="isEditVisible" :flowChartData="selectFlowChart&&selectFlowChart[0]" />
  </div>
</template>
<script>
import EbHeader from '@/components/common/eb-header';
import EbBreakCrumb from '@/components/common/eb-break-crumb';
import ebSearch from '@/components/common/eb-search';
import SaveFlowChart from '@/components/flowchart/SaveFlowChart';
import EditFlowChart from '@/components/flowchart/EditFlowChart';
import ebPagination from '@/components/common/eb-pagination/eb-pagination';
import FlowchartBtnView from '@/components/common/button/flowchart/FlowchartBtnView';
import FlowchartBtnEdit from '@/components/common/button/flowchart/FlowchartBtnEdit';
import { findFlowChartListByUserId, removeFlowChart } from '@/services/flowchart-service';
export default {
  name: 'flowChartList',
  components: {
    EbHeader,
    EbBreakCrumb,
    ebSearch,
    SaveFlowChart,
    EditFlowChart,
    ebPagination,
    FlowchartBtnView,
    FlowchartBtnEdit
  },
  data() {
    return {
      user: this.$store.state.user.userInfo,
      flowChartParams: {
        number: 10,
        page: 1,
        userId: this.$store.state.user.userInfo.userid,
        content: ''
      },
      flowChartList: [],
      selectFlowChart: [],
      listSize: 0,
      isSaveVisible: false,
      isEditVisible: false
    };
  },
  created() {
    this.init();
  },
  methods: {
    resetParams: function() {
      this.flowChartParams = {
        number: 10,
        page: 1,
        userId: this.user.userid,
        content: ''
      };
    },
    async init() {
      this.$root.layout.isLoading = true;
      try {
        let { data } = await findFlowChartListByUserId(this.flowChartParams);
        if (data.returnCode === '01') {
          this.flowChartList = data.flowChartList;
          this.listSize = data.listSize;
        } else {
          this.$message.error('获取流程图列表失败');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
      this.$root.layout.isLoading = false;
    },
    searchData: function(data) {
      this.resetParams();
      this.flowChartParams.content = data;
      this.init();
    },
    paginationData: function(data) {
      this.flowChartParams.page = data;
      this.init();
    },
    handleSelectionChange: function(data) {
      this.selectFlowChart = data;
    },
    removeFlowChartBtn: function() {
      this.$ebConfirm('确定要删除吗')
        .then(() => {
          this.removeFlowChartService();
        })
        .catch(() => {});
    },
    async removeFlowChartService() {
      try {
        let params = {
          updateId: this.user.userid,
          flowId: this.selectFlowChart[0].flowId
        };
        let { data } = await removeFlowChart(params);
        if (data.returnCode === '01') {
          this.$message.success('删除成功');
          this.$nextTick(() => {
            this.$refs.flowChartRef.clearSelection();
          });
          this.resetParams();
          this.init();
        } else if (data.returnCode === '03') {
          this.$message.error(data.message);
        } else {
          this.$message.error('删除流程图失败');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    onSuccess: function() {
      this.$nextTick(() => {
        this.$refs.flowChartRef.clearSelection();
      });
      this.resetParams();
      this.init();
    },
    editFlowChartBtn: function() {
      let ebFlowChart = {
        flowId: this.selectFlowChart[0].flowId,
        userId: this.user.userid
      };
      sessionStorage.setItem('ebFlowChart', JSON.stringify(ebFlowChart));
      if (process.env.NODE_ENV === 'production') {
        window.open('/flowchart/edit');
      } else {
        window.open('/static/ebmxgraph/grapheditor/editor.html');
      }
    }
  }
};
</script>
<style lang="less" scoped>
#flowChartList {
  .button-group {
    display: flex;
    justify-content: flex-end;
    padding-right: 51px;
    padding-top: 30px;
  }
  .pagination-box {
    padding-top: 20px;
  }
}
</style>
